













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class ImageLazyLoader extends Vue {
  @Prop(String) private src!: string;
  @Prop(String) private alt!: string;

  private isLoaded: boolean = false;
  private loadedAspectRatio: number | null = null;
  private clientWidth: number = 0;

  private mounted() {
    const img = (this.$refs.img) as any;
    const sizeInterval = setInterval(() => {
      if (img.naturalWidth!) {
        clearInterval(sizeInterval);
        this.loadedAspectRatio = img.naturalWidth / img.naturalHeight;
      }
    }, 10);

    window.addEventListener('resize', this.updateClientWidth);
    this.updateClientWidth();
  }

  private loaded() {
    this.isLoaded = true;
  }

  private updateClientWidth() {
    this.clientWidth = (this.$refs.placeholder as any).clientWidth;
  }

  /**
   * Calculates the height of the placeholder
   * via the images nativeWidth and nativeHeight.
   */
  get placeholderHeight() {
    if (!this.loadedAspectRatio) {
      return 0;
    }

    return this.clientWidth / this.loadedAspectRatio!;
  }
}
